<template>
  <m-card202 class="commentCard1 border p-2 rounded-sm">
    <template #p-1>
      <img :src="isUserAvatar" :alt="commentUser.name" class="avatar-icon">
      <span class="mr-2">
        {{ userAndLastname }}

      </span>
    </template>
    <template #p-2>
      <div class="row justify-content-md-end justify-content-start commentCard1-data-and-rating p-3">
             <span class="border rounded-sm ml-2 px-1">
               <i class="star-rate bi bi-star-fill"></i>
               {{ comment.rate }}
             </span>
        {{ dateConverter(comment.created_at, '/', true) }}
      </div>
    </template>
    <template #p-3>
      <div class="font-weight-light col-12 my-1" v-html="comment.body"></div>
      <div class="">
        <hr>
        <div class="px-1">
          <div class="text-left ">
            <button class="btn btn-primary rounded-pill" type="button" data-toggle="collapse"
                    :data-target="`#${generateHashMaker}`"
                    aria-expanded="false" aria-controls="collapseExample" v-t="`comment.reply.button_text`">
            </button>
          </div>

          <div class="collapse my-3" :id="generateHashMaker">

            <comment-form1 :parent_id="comment.id" :commentable_id="comment.commentable_id"
                           :commentable_type="comment.commentable_type" class="my-3"/>

          </div>

        </div>

      </div>

      <template v-if="repliesStatus" v-for="(reply,index) in comment.replies">
        <div class="my-3" :style="`padding: 0 ${(index+1)*5}px !important`">
          <comment-card1 :comment="reply"/>
        </div>
      </template>


    </template>
  </m-card202>
</template>

<script>
import {defineComponent} from 'vue'
import mRate1 from "../Rate/Rate1.vue";
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import mCard202 from "../../Cards/Card202";

import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import mA from "../../Tags/A.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import CommentForm1 from "../../Comment/Form/CommentForm1.vue";

export default defineComponent({
  name: "CommentCard1",
  components: {CommentForm1, FormErrorsManager, mA, mRate1, mCard202},
  props: {
    comment: {}
  },
  data() {
    return {
      userAvatar
    }
  },
  computed: {
    ...mapGetters({
      'isAuthenticated': 'User/isAuthenticated'
    }),
    commentUser() {
      return this.comment.user;
    },
    isUserAvatar() {

      let userImage = this.comment.user.image;
      if (userImage == null) {
        return this.userAvatar;
      }

      return userImage
    },
    repliesStatus() {
      if (!Object.keys(this.comment).includes('replies')) {
        return false
      }

      let replies = this.comment.replies;
      if (replies.length > 0) {
        return true;
      }

      return false
    },
    userAndLastname() {
      return this.comment.user.name + ' ' + this.comment.user.last_name;
    },
    generateHashMaker() {
      return `reply-comment-${generateHash()}`
    }
  },
  methods: {
    dateConverter,
  }
})
</script>

<style scoped>
.commentCard1-data-and-rating {
  font-size: small;
}

.avatar-icon {
  width: 30px;
  height: 30px;
}

.star-rate {
  color: #FFD83D;
  font-size: small;
}
</style>